import React from 'react';
import PropTypes from 'prop-types';

import StyledComponent from '~/components/Styled/Styled';
import css from '~/components/TeamRoster/TeamRoster.scss';
import TeamRosterPlayer from '~/components/TeamRoster/TeamRosterPlayer/TeamRosterPlayer';
import groupBy from 'lodash/groupBy';

class TeamRoster extends React.PureComponent {
  render() {
    const { players } = this.props;
    const sortedPlayers = groupBy(players, 'position');

    return (
      <div className={css.container}>
        {Object.keys(sortedPlayers).map(position => (
          <span key={`position-${position}`}>
            <div className={css.positionHeader}>{position}</div>
            <div className={`${css.positionContainer} row`}>
              {sortedPlayers[position].map(player => (
                <TeamRosterPlayer key={`player-${player.name}`} player={player} />
              ))}
            </div>
          </span>
        ))}
      </div>
    );
  }
}

TeamRoster.displayName = 'TeamRoster';

TeamRoster.propTypes = {
  players: PropTypes.array.isRequired,
};

export default StyledComponent(TeamRoster, [css]);
